// @flow
import * as React from 'react'
import { useTranslation } from 'react-i18next'

import {
  Api,
  createApiData,
  standartRequests,
  type OccurType,
  type ErrorByIdType,
  type RequestFuncType,
  type StandartRequestFuncType,
  type UpdateFn,
} from 'app/common/context/Api'

export const CustomerSettings = createApiData()

/**
 * DEPRECATED use useCustomerSettings.js
 */

const makeRequestsData = (id, t) =>
  id
    ? {
        customerSettings: {
          path: 'cafeteria/customer/settings',
          type: 'get',
          rest: { params: { customer_id: id } },
          cbErrorTextCreate: (/* error */) =>
            t(
              'customer_settings_fetch_error',
              'Не удалось получить данные настроек пользователя столовой',
            ),
          autoRequest: true,
        },
      }
    : {}

type State = {
  content: {
    balance?: number,
    common_limit?: number,
    personal_limit?: number,
    pin_enabled?: boolean,
    pin_activated?: boolean,
    pin_reason?: string,
    purchase_available_on?: number,
    has_presales?: number,
    has_presales_time?: boolean,
  },
  loading: boolean,
  occur: OccurType,
  request: {
    customerSettings: RequestFuncType,
    // стандартные запросы, если в Api передается addStandartRequests
    [$Values<typeof standartRequests>]: StandartRequestFuncType,
  },
  error?: { [string]: mixed },
  errorById?: ErrorByIdType,
  updateFn: UpdateFn,
}

type Props = {
  personId: number,
  children: React.Node | ((value: State) => React.Node),
  addStandartRequests?: boolean,
}

const CustomerSettingsApi = ({ children, personId, addStandartRequests }: Props) => {
  const { t } = useTranslation('cafeteria')
  const descriptions = React.useMemo(() => makeRequestsData(personId, t), [personId, t])

  return (
    <Api
      apiData={CustomerSettings}
      descriptions={descriptions}
      addStandartRequests={addStandartRequests}
    >
      {children}
    </Api>
  )
}

export default CustomerSettingsApi
